<template>
    <div id="importjob">
        <v-container id="importjob__container">
            <v-row>
                <v-col :cols="3" id="importjob__container--row">
                    <v-select
                        label="Timeframe"
                        :items="timeframe"
                        outlined
                        dense
                        v-model="getLogs"
                    />
                </v-col>
                <v-col :cols="9" v-if="logs.length > 0">
                    <Pagination
                        :isloading="isloading"
                        :startRecord="startRecord"
                        :currentPage="currentPage"
                        :lastPage="lastPage"
                        :lastRecord="lastRecord"
                        :totRecords="totRecords"
                        :isCurrentPageClass="isCurrentPageClass"
                        :perpage="perpage"
                        :getLastPageClass="getLastPageClass"
                        :totPage="totPage"
                        :getPages="getPages"
                        @handlePerPage="handlePerPage"
                        @paginate="paginate"
                        @last="last"
                        @getDataByPage="getDataByPage"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col :cols="16" v-if="logs.length > 0">
                    <v-card>
                        <v-list id="importjob__list">
                            <v-list-item-group>
                                <v-list-item id="importjob__list--header">
                                    <v-list-item-content id="importjob__list--header__1"><b>Muid</b></v-list-item-content>
                                    <v-list-item-content id="importjob__list--header__2"><b>Original Muid</b></v-list-item-content>
                                    <v-list-item-content id="importjob__list--header__3"><b>Email Date</b></v-list-item-content>
                                    <v-list-item-content id="importjob__list--header__4"><b>MimeType</b></v-list-item-content>
                                    <v-list-item-content id="importjob__list--header__5"><b>S3 Content Length</b></v-list-item-content>
                                    <v-list-item-content id="importjob__list--header__6"><b>Status</b></v-list-item-content>
                                    <v-list-item-content id="importjob__list--header__6"><b>Status Code</b></v-list-item-content>
                                </v-list-item>
                                <Logs v-for="(l, k) in logs" v-bind:key="k" :log="l" :class="emailClass(k)"/>
                            </v-list-item-group>
                        </v-list>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Logs from './../components/Logs'
import Pagination from './../components/Pagination'

export default {
    name: 'ImportJobLogs',
    data: () => ({
        timeframe: [],
        getLogs: '',
    }),
    components: {
        Logs,
        Pagination,
    },
    mounted() {
        // content shifted to watch
    },
    methods: {
        emailClass: function(i) {
            return parseInt(i)%2 === parseInt(0) ? 'grey lighten-2' : 'grey lighten-5'
        },
        handlePerPage: function(p) {
            var view = this
            view.$store.dispatch('ImportJobLogs/setPerPage', p).then(function () {
                return view.$store.dispatch('ImportJobLogs/setPage', parseInt(1))
            }).then(function () {
                view.$utils.fetchLogs(view)
            }).catch(function (e) {
                console.log(e)
            })
        },
        paginate: function(n) {
            var view = this
            if (parseInt(n) === parseInt(0) && parseInt(this.currentPage) === parseInt(1)) {
                return
            }
            if (parseInt(n) === parseInt(-1)) {
                if (parseInt(this.currentPage) <= parseInt(1)) {
                    return
                }
            }
            if (parseInt(n) === parseInt(1)) {
                if (parseInt(this.currentPage) >= parseInt(this.lastPage)) {
                    return
                }
            }
            view.$store.dispatch('ImportJobLogs/setPage', n === 0 ? 1 : parseInt(view.currentPage) + parseInt(n)).then(function() {
                view.$utils.fetchLogs(view)
            })
        },
        last: function() {
            const view = this
            if (parseInt(view.lastPage) === parseInt(view.currentPage)) {
                return
            }
            view.$store.dispatch('ImportJobLogs/setPage', view.lastPage).then(function () {
                view.$utils.fetchLogs(view)
            })
        },
        getDataByPage: function(page) {
            var view = this
            view.$store.dispatch('ImportJobLogs/setPage', page).then(function () {
                view.$utils.fetchLogs(view)
            })
        }
    },
    computed: {
        logs: function() {
            return this.$store.getters['ImportJobLogs/getResponsePayload']
        },
        isloading: function () {
            return false
        },
        startRecord: function () {
            return parseInt(this.lastRecord) - parseInt(this.perpage) + parseInt(1)
        },
        currentPage: function () {
            return this.$store.getters['ImportJobLogs/getPage']
        },
        lastPage: function () {
            return this.$store.getters['ImportJobLogs/getLastPage']
        },
        lastRecord: function () {
            return this.perpage * this.currentPage
        },
        totRecords: function () {
            return this.$store.getters['ImportJobLogs/getLogCounts']
        },
        isCurrentPageClass: function () {
            return this.currentPage === 1 ? "" : "notactivespan"
        },
        perpage: function () {
            return this.$store.getters['ImportJobLogs/getPerPage']
        },
        getLastPageClass: function () {
            return parseInt(this.lastPage) === parseInt(this.currentPage) ? "" : "notactivespan"
        },
        totPage: function () {
            return Math.ceil(parseInt(this.totRecords) / parseInt(this.perpage))
        },
        getPages: function () {
            return this.$utils.getPages(this.lastPage, this.currentPage, this.totPage)
        },
    },
    watch: {
        '$store.state.RawData.current_active_module': function(o){
            if(o){
                    var view = this
                let nodes = document.querySelectorAll(".v-text-field__details"), size = nodes.length
                for (let i = 0; i < size; i++) {
                    nodes[i].style.display = 'none'
                }
                view.$fetch({
                    url: view.$url('IMPORT_JOB'),
                    type: 'GET',
                },{
                        operation: 'view',
                        vueScope: view
                    }).then(function(response) {
                    response.forEach(function(o) {
                        view.timeframe.push({
                            text: view.$utils.mdy_format(o.start_time) + " - " + view.$utils.mdy_format(o.end_time),
                            value: o.id,
                        })
                    })
                })
            }
        },
        getLogs: function(o) {
            var view = this
            this.$store.dispatch('ImportJobLogs/setResponsePayload', []).then(function() {
                view.$store.dispatch('ImportJobLogs/setCronLogId', o).then(function() {
                    view.$utils.fetchLogs(view)
                })
            })
        },
    }
}
</script>
<style lang="sass" scoped>
@import "./../assets/sass/importjoblogs.sass"
</style>